import { render, staticRenderFns } from "./ad-detail.vue?vue&type=template&id=f10b13c4&scoped=true"
import script from "./ad-detail.vue?vue&type=script&lang=js"
export * from "./ad-detail.vue?vue&type=script&lang=js"
import style0 from "./ad-detail.vue?vue&type=style&index=0&id=f10b13c4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10b13c4",
  null
  
)

export default component.exports